import Seo from '../../components/Seo/Seo';
import styles from './TermsPage.module.css';

export default function TermsPage() {
	return (
		<>
			<Seo
				title="Általános Szerződési Feltételek (ÁSZF) - Akku 24+"
				description="Az Akku 24+ vásárlási feltételei, felelősségkizáró nyilatkozata és garanciális feltételei."
			/>

			<div className={styles.page}>
				<div className={styles.container}>
					<h1 className={styles.heading}>Általános Szerződési Feltételek (ÁSZF)</h1>
					<p className={styles.effectiveDate}>Hatályos: 2026. június 11-től visszavonásig</p>

					<section className={styles.section}>
						<h2 className={styles.sectionTitle}>1. A szolgáltató adatai</h2>
						<div className={styles.textContent}>
							<p>
								<strong>TIPCOOP Gyártó, Szolgáltató és Kereskedő Kft.</strong>
								<br />
								Székhely: 1027 Budapest, Margit körút 64/B.
								<br />
								Telephely (garanciális ügyintézés): 1132 Budapest, Váci út 8.
								<br />
								Adószám: 10365324-2-41
								<br />
								Cégjegyzékszám: 01 09 067412
								<br />
								Ügyfélszolgálat: +36-30-626-6000
							</p>
						</div>
					</section>

					<section className={styles.section}>
						<h2 className={styles.sectionTitle}>2. Vásárlási feltételek</h2>
						<div className={styles.textContent}>
							<p>Az akkumulátor segélyszolgálat a következő szolgáltatásokat tartalmazza:</p>
							<ul>
								<li>Az akkumulátor kiszállítása</li>
								<li>
									A használt akkumulátor kiszerelése és elszállítása (cégünk rendelkezik az akkumulátor
									elszállítására és tárolására vonatkozó engedélyekkel és szerződésekkel)
								</li>
								<li>Az új akkumulátor beszerelése</li>
								<li>A gépjármű töltésének ellenőrzése</li>
							</ul>
							<p>
								A későbbi garanciális problémák kezelése cégünk telephelyén, a 1132 Budapest, Váci út 8. szám alatt, és nem a kiszállítás helyszínén történik, mivel a vizsgálat és a csere
								feltételei kizárólag itt megoldhatók.
							</p>
							<p>
								Amennyiben a kiszállás időpontjában a megrendelő nem jelenik meg a kiszállás helyszínén, a
								kiszállás díjának megfizetése ettől függetlenül esedékessé válik.
							</p>
							<p>
								Amennyiben az akkumulátor cseréje nem orvosolja a gépjármű problémáját, a megrendelő
								dönthet afelől, hogy átveszi-e az akkumulátort, viszont a kiszállítás díja mindkét esetben
								fizetendő.
							</p>
						</div>
					</section>

					<section className={styles.section}>
						<h2 className={styles.sectionTitle}>3. A megrendelt szolgáltatás lemondása</h2>
						<div className={styles.textContent}>
							<p>
								A megrendelt kiszállás a szerelő visszaigazoló SMS-ének elküldését követően nem mondható
								le, kizárólag a szolgáltatási díj teljes rendezése után. Az SMS megérkezéséig a
								megrendelés szabadon módosítható vagy visszamondható az ügyfélszolgálaton keresztül a
								+36-30-626-6000 telefonszámon.
							</p>
						</div>
					</section>

					<section className={styles.section}>
						<h2 className={styles.sectionTitle}>4. Felelősségkizáró nyilatkozat</h2>
						<div className={styles.textContent}>
							<p>
								Ezúton tájékoztatjuk Tisztelt Ügyfelünket, hogy cégünk akkumulátor kiszállítási és
								helyszíni beszerelési szolgáltatásai során a lehető legnagyobb gondossággal járunk el.
								Ugyanakkor felhívjuk figyelmét, hogy a gépjárművek műszaki sokfélesége, az egyes
								típusokra jellemző elektronikai érzékenység, valamint a kiszállás körülményei miatt
								szolgáltatásunk igénybevételével Ügyfelünk elfogadja az alábbi feltételeket:
							</p>
							<ul>
								<li>
									Nem áll módunkban felelősséget vállalni olyan károkért, amelyek az akkumulátor cseréje,
									csatlakoztatása, kiszerelése, a beszerelt akkumulátor kapcsán vagy rendkívüli indítási
									kísérlet során keletkeznek.
								</li>
								<li>
									Nem áll módunkban felelősséget vállalni az olyan elektronikai meghibásodásokért,
									amelyek a jármű fedélzeti rendszereiben keletkeznek, beleértve, de nem kizárólag a
									következőket: ECU modulok, a gépjárművek elektronikus rendszere, szenzorok,
									vezérlőmodulok, elektromos csatlakozók, egyéb elektronikus vagy mechanikai elemek vagy
									alrendszerek.
								</li>
								<li>
									Nem áll módunkban felelősséget vállalni a gépjármű komputerét érintő hibakódok és a
									gépjármű mozgásképtelensége kapcsán. A mozgásképtelenségből adódó szervizbe szállítás,
									javíttatás, valamint egyéb kapcsolódó költségek az Ügyfelet terhelik.
								</li>
								<li>
									A modern járművek áramellátása érzékeny a megszakításokra és a
									feszültségingadozásokra. Az ilyen események szerelés közbeni esetleges kockázata az
									Ügyfelet terheli.
								</li>
								<li>
									Nem áll módunkban felelősséget vállalni fizikai sérülésekért (karosszéria, fényezés,
									belső tér, műanyag idomok, műanyag patentek), ha azok a kiszállás, szerelés vagy
									indítás alkalmával következnek be, kivéve szándékosság vagy súlyos gondatlanság
									esetén.
								</li>
								<li>
									Amennyiben az indítási problémát nem az akkumulátor okozza, és az új akkumulátor sem
									oldja meg a hibát, Ügyfelünk nem köteles azt megvásárolni. Ebben az esetben csak a
									kiszállási díj fizetendő.
								</li>
							</ul>
							<p>
								A honlapon közölt információk helyességéért az Akku 24+ üzemeltetője vállalja a
								felelősséget, ennek maximuma az esetleges újabb kiszállás díja (térítésmentes második
								kiszállás).
							</p>
						</div>
					</section>

					<section className={styles.section}>
						<h2 className={styles.sectionTitle}>5. Garanciális feltételek</h2>
						<div className={styles.textContent}>
							<ul>
								<li>
									A Tip-Coop Kft. 12 vagy 24 hónap garanciát vállal kizárólag gyártásból eredő hibára az
									általa forgalmazott és megjelölt akkumulátorokra, típustól függően. A pontos
									garanciális időtartamot a vásárláskori garanciajegy tartalmazza.
								</li>
								<li>Taxiban vagy kisteherautókban való üzemeltetés esetén a jótállási idő 6 hónap.</li>
							</ul>
							<p>
								<strong>A garancia érvényét veszti az alábbi esetekben:</strong>
							</p>
							<ul>
								<li>Külső mechanikus sérülés.</li>
								<li>Nem előírt típusú akkumulátor beszerelése.</li>
								<li>Szulfátosodás, túltöltés, lemerülés, megfagyás.</li>
								<li>Mélykisülés (kapocsfeszültség 10,4 V alá csökken).</li>
							</ul>
							<p>
								<strong>Garancia meghosszabbítása:</strong> Amennyiben a garancia időtartama 12 hónap, az
								kizárólag abban az esetben hosszabbodik meg további 12 hónappal, ha a vásárlástól
								számított 12. hónapban az akkumulátor és a gépjármű állapotát a 1132 Budapest, Váci út 8.
								szám alatti Autósboltban díjmentesen ellenőriztetik. A vizsgálatról jegyzőkönyv készül,
								mely a meghosszabbított garancia feltétele. Vizsgálat hiányában a garancia időtartama
								legfeljebb 12 hónap.
							</p>
						</div>
					</section>

					<section className={styles.section}>
						<h2 className={styles.sectionTitle}>6. Garancia érvényesítése</h2>
						<div className={styles.textContent}>
							<p>
								A garancia időtartama és feltételei a termékhez mellékelt garanciajegyben szerepelnek.
								Garanciális ügyintézés kizárólag személyesen vagy postai úton történhet az alábbi címen:
								1132 Budapest, Váci út 8. A helyszíni garanciális ügyintézés technikai okok miatt
								nem lehetséges.
							</p>
							<p>
								<strong>Fontos:</strong> A számla és a garanciajegy megléte elengedhetetlen a garanciális
								ügyintézéshez.
							</p>
						</div>
					</section>

					<section className={styles.section}>
						<h2 className={styles.sectionTitle}>7. Záró rendelkezések</h2>
						<div className={styles.textContent}>
							<p>
								Ügyfelünk a szolgáltatás megrendelésével és igénybevételével kifejezetten kijelenti, hogy
								a jelen dokumentumban foglalt feltételeket, felelősségkizárást és garanciális feltételeket
								tudomásul veszi, és ezekkel kapcsolatban nem támaszt kártérítési igényt a TIPCOOP Kft.-vel
								szemben.
							</p>
						</div>
					</section>
				</div>
			</div>
		</>
	);
}
